import React, { useEffect, useState } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { initializeGoogleConsent, updateConsentSettings } from '@/lib/gtag';

export const showPreferences = () => {
  CookieConsent.showPreferences();
};

export const resetConsent = () => {
  CookieConsent.reset(true);
};

const CookieConsentManager = () => {
  const [loadScript, setLoadScript] = useState(false);

  useEffect(() => {
    if (window._ccRun) return;

    // Initialize Google consent mode
    initializeGoogleConsent();

    const updateGtagConsent = () => {
      updateConsentSettings({
        advertisement: CookieConsent.acceptedCategory('advertisement'),
        analytics: CookieConsent.acceptedCategory('analytics'),
        functional: CookieConsent.acceptedCategory('functional'),
      });
    };

    // Configure cookie consent
    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'cloud inline',
          position: 'bottom center',
          equalWeightButtons: true,
          flipButtons: false
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        functional: {},
        analytics: {},
        advertisement: {}
      },
      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: {
              title: 'We use cookies',
              description: 'This website uses essential cookies to ensure its proper functioning and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Manage preferences',
            },
            preferencesModal: {
              title: 'Cookie Preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Save preferences',
              closeIconLabel: 'Close modal',
              serviceCounterLabel: 'Service|Services',
              sections: [
                {
                  title: 'Cookie Usage',
                  description: 'We use cookies to ensure basic website functionality and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.'
                },
                {
                  title: 'Strictly Necessary Cookies',
                  description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                  linkedCategory: 'necessary'
                },
                {
                  title: 'Functional Cookies',
                  description: 'These cookies enable personalized features and functionality.',
                  linkedCategory: 'functional'
                },
                {
                  title: 'Analytics Cookies',
                  description: 'These cookies help us understand how visitors interact with the website, helping us improve our services.',
                  linkedCategory: 'analytics'
                },
                {
                  title: 'Advertisement Cookies',
                  description: 'These cookies are used to deliver relevant advertisements and track ad campaign performance.',
                  linkedCategory: 'advertisement'
                },
                {
                  title: 'More Information',
                  description: 'For questions about our cookie policy and your choices, please contact us.'
                }
              ]
            }
          }
        }
      },
      onFirstConsent: () => {
        setLoadScript(true);
      },
      onConsent: updateGtagConsent,
      onChange: updateGtagConsent,
    });

    return () => {
      CookieConsent.reset(true);
    };
  }, []);

  return loadScript ? (
    <script
      async
      src={`https://www.googletagmanager.com/gtag/js?id=G-LD53SPH1Y2`}
    />
  ) : null;
};

export default CookieConsentManager;
